(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["health-needs"] && !Shopify.designMode) return;
  try {
    
  (function () {
    document.querySelectorAll('[data-hn-section]').forEach(function (root) {
      // --- Tabs ---
      var tabs = root.querySelectorAll('[data-hn-tab]');
      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var targetId = tab.getAttribute('data-tab-target');
          tabs.forEach(function (t) {
            t.classList.remove('hn-tab--active');
            t.setAttribute('aria-selected', 'false');
          });
          tab.classList.add('hn-tab--active');
          tab.setAttribute('aria-selected', 'true');

          root.querySelectorAll('[data-hn-panel]').forEach(function (panel) {
            if (panel.id === targetId) {
              panel.hidden = false;
              panel.classList.add('hn-panel--active');
            } else {
              panel.hidden = true;
              panel.classList.remove('hn-panel--active');
            }
          });
        });
      });

      // --- Pack selector ---
      root.querySelectorAll('[data-product-card]').forEach(function (card) {
        var packBtns = card.querySelectorAll('[data-pack-btn]');
        var addBtn = card.querySelector('[data-add-to-cart]');
        var currentPriceEl = card.querySelector('[data-current-price]');
        var comparePriceEl = card.querySelector('[data-compare-price]');
        var offEl = card.querySelector('[data-off-price]');

        packBtns.forEach(function (btn) {
          btn.addEventListener('click', function () {
            if (btn.disabled) return;
            packBtns.forEach(function (b) { b.classList.remove('hn-pack-btn--active'); });
            btn.classList.add('hn-pack-btn--active');

            var variantId = btn.getAttribute('data-variant-id');
            var price = parseInt(btn.getAttribute('data-price'), 10);
            var comparePrice = parseInt(btn.getAttribute('data-compare-price'), 10);

            if (addBtn && variantId) addBtn.setAttribute('data-variant-id', variantId);

            if (currentPriceEl && !isNaN(price)) {
              currentPriceEl.textContent = formatMoney(price);
            }
            if (!isNaN(comparePrice) && comparePrice > price) {
              comparePriceEl.hidden = false;
              offEl.hidden = false;
              comparePriceEl.textContent = formatMoney(comparePrice);
              offEl.textContent = Math.round(((comparePrice - price) / comparePrice) * 100) + '% off';
            } else {
              comparePriceEl.hidden = true;
              offEl.hidden = true;
            }
          });
        });

        // --- Wishlist (cosmetic toggle; wire to your wishlist app/metafield as needed) ---
        var wishlistBtn = card.querySelector('[data-wishlist-toggle]');
        if (wishlistBtn) {
          wishlistBtn.addEventListener('click', function () {
            var pressed = wishlistBtn.getAttribute('aria-pressed') === 'true';
            wishlistBtn.setAttribute('aria-pressed', String(!pressed));
          });
        }

        // --- Add to cart ---
        if (addBtn) {
          addBtn.addEventListener('click', function () {
            var variantId = addBtn.getAttribute('data-variant-id');
            if (!variantId || addBtn.disabled) return;

            addBtn.setAttribute('data-loading', 'true');
            var label = addBtn.querySelector('[data-add-to-cart-label]');
            var originalText = label ? label.textContent : '';
            if (label) label.textContent = 'Adding...';

            fetch(window.Shopify && window.Shopify.routes && window.Shopify.routes.root
              ? window.Shopify.routes.root + 'cart/add.js'
              : '/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
              body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
            })
              .then(function (res) { return res.json(); })
              .then(function () {
                if (label) label.textContent = 'Added';
                document.dispatchEvent(new CustomEvent('cart:refresh'));
                setTimeout(function () {
                  if (label) label.textContent = originalText;
                  addBtn.removeAttribute('data-loading');
                }, 1200);
              })
              .catch(function () {
                if (label) label.textContent = 'Error — try again';
                addBtn.removeAttribute('data-loading');
              });
          });
        }
      });
    });

    function formatMoney(cents) {
      // Falls back to a plain decimal format; replace with Shopify.formatMoney
      // and your money_format setting for full currency-format support.
      return (cents / 100).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
